// extracted by mini-css-extract-plugin
module.exports = {"indicator":"_1rAEEedMEjpag1M6bdvHyE","current":"_1fi5HMO6nwWwNKI2sUQPx-"};